import { render, staticRenderFns } from "./OrderDrawer.vue?vue&type=template&id=7b7e63c8&scoped=true"
import script from "./OrderDrawer.vue?vue&type=script&lang=js"
export * from "./OrderDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderDrawer.vue?vue&type=style&index=0&id=7b7e63c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7e63c8",
  null
  
)

export default component.exports